import Card from "./card";
import { Box } from "@mui/material";
import styles from "./style.module.css";
import { useSelector } from "react-redux";

const Hosted = () => {
  const {
    data: { hostedProjects },
  } = useSelector((state) => state.manageProjects);

  const renderProjects = hostedProjects?.map((project, index) => {
    return <Card project={project} key={index} />;
  });

  return <Box className={styles.hosted}>{renderProjects}</Box>;
};

export default Hosted;
